/*
 * @Author: changcheng
 * @LastEditTime: 2023-04-11 14:09:13
 */
import React, { useEffect, FC, useState } from "react";
import { connect } from "react-redux";

import "./index.less";
import axios from "@/axios/axios";
import { message } from "antd";

const Advertisement: FC<any> = ({ history, list = [] }) => {
  // 广告图片
  const [imgs, setImgsList] = useState([]);
  const getImgs = async () => {
    const { code, data, msg }: any = await axios.post("/main/front/ce/ad/list");
    if (code === 0) {
      setImgsList(data || []);
    } else {
      message.error(msg);
    }
  };
  useEffect(() => {
    getImgs();
  }, []);

  const imgJump = (data: any) => {
    if (data.clickUrl) {
      window.open(data.clickUrl);
    }
  };

  return (
    <div className={"advertisement-module"}>
      {imgs.map((item: any, i: number) => (
        <div key={i} className={"img-box"}>
          <img
            onClick={() => {
              imgJump(item);
            }}
            key={i}
            src={item.imageAllPathUrl}
            alt=""
          />
        </div>
      ))}
    </div>
  );
};

export default connect((state) => state)(Advertisement);
